module.exports = __webpack_public_path__ + "media/images/city_img/j_4-b7b82a477aca44076f4a3f75d4eb8957.jpg";